import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import { getFacilityAndDepartmentFromDepartmentId } from "reduxSlices/facilitiesSlice"

const AuditLocationAnswer = ({ value = {} }) => {
  const [facility, department] = useSelector(getFacilityAndDepartmentFromDepartmentId(value?.department_id))

  const { name: facilityName } = useCustomName(FACILITY_KEY)
  const { name: departmentName } = useCustomName(DEPARTMENT_KEY)

  if (!value?.department_id) return (<span />)

  return (
    <span>
      {facilityName}: {facility.name}, {departmentName}: {department.name}
    </span>
  )
}

AuditLocationAnswer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: types.object,
}

export default AuditLocationAnswer
